import { Aircraft } from '../../types/intellijetnet'
import { MarketCustomColumn } from '../../types/database'
import { ExportOptions } from '../pdf-export/ExportOptionsModal'
import { PreviewData } from '../../hooks/useMarketPDFExport'
import AircraftSearchModal from '../aircraft/AircraftSearchModal'
import AddOffMarketAircraftForm from './AddOffMarketAircraftForm'
import ExportOptionsModal from '../pdf-export/ExportOptionsModal'
import PDFPreviewModal from '../pdf-export/PDFPreviewModal'

interface MarketModalsProps {
  modelId: string
  modelInfo: { model_name: string; make_name: string } | null
  customColumns: MarketCustomColumn[]
  historicalMonths: number
  // Aircraft search modal
  showAircraftSearchModal: boolean
  setShowAircraftSearchModal: (show: boolean) => void
  handleSelectAircraft: (aircraft: Aircraft) => void
  // Add off-market form
  selectedAircraftForForm: Aircraft | null
  handleOffMarketSuccess: () => void
  handleOffMarketCancel: () => void
  // Export options modal
  showExportOptionsModal: boolean
  setShowExportOptionsModal: (show: boolean) => void
  handlePreviewPDF: (options: ExportOptions) => Promise<void> | void
  // PDF preview modal
  showPDFPreviewModal: boolean
  setShowPDFPreviewModal: (show: boolean) => void
  handleDownloadFromPreview: (editedData: Map<number, { owner?: string; broker?: string }>) => void
  handleUpdateOptionsFromPreview?: (options: ExportOptions) => Promise<void> | void
  previewData: PreviewData | null
}

export default function MarketModals({
  modelId,
  modelInfo,
  customColumns,
  historicalMonths,
  showAircraftSearchModal,
  setShowAircraftSearchModal,
  handleSelectAircraft,
  selectedAircraftForForm,
  handleOffMarketSuccess,
  handleOffMarketCancel,
  showExportOptionsModal,
  setShowExportOptionsModal,
  handlePreviewPDF,
  showPDFPreviewModal,
  setShowPDFPreviewModal,
  handleDownloadFromPreview,
  handleUpdateOptionsFromPreview,
  previewData,
}: MarketModalsProps) {
  return (
    <>
      {/* Aircraft Search Modal */}
      <AircraftSearchModal
        isOpen={showAircraftSearchModal}
        onClose={() => setShowAircraftSearchModal(false)}
        modelId={parseInt(modelId, 10)}
        onSelectAircraft={handleSelectAircraft}
      />

      {/* Add Off Market Aircraft Form */}
      {selectedAircraftForForm && (
        <AddOffMarketAircraftForm
          isOpen={!!selectedAircraftForForm}
          aircraft={selectedAircraftForForm}
          modelId={parseInt(modelId, 10)}
          onSuccess={handleOffMarketSuccess}
          onCancel={handleOffMarketCancel}
        />
      )}

      {/* Export Options Modal */}
      <ExportOptionsModal
        isOpen={showExportOptionsModal}
        onClose={() => setShowExportOptionsModal(false)}
        onContinue={handlePreviewPDF}
        customColumns={customColumns}
        initialHistoricalMonths={historicalMonths}
      />

      {/* PDF Preview Modal */}
      {previewData && (
        <PDFPreviewModal
          isOpen={showPDFPreviewModal}
          onClose={() => setShowPDFPreviewModal(false)}
          onDownload={handleDownloadFromPreview}
          onUpdateOptions={handleUpdateOptionsFromPreview}
          tables={previewData.tables}
          overrides={previewData.overrides}
          options={previewData.options}
          relativeValues={previewData.relativeValues}
          relativeValueBreakdowns={previewData.relativeValueBreakdowns}
          missingABB={previewData.missingABB}
          exportOptions={previewData.exportOptions}
          customColumns={customColumns}
          companies={previewData.companies}
          transactionOverrides={previewData.transactionOverrides}
          transactionOptionDetails={previewData.transactionOptionDetails}
          modelName={modelInfo?.model_name || ''}
          makeName={modelInfo?.make_name || ''}
          manufacturer={previewData.manufacturer}
          marketStatistics={previewData.marketStatistics}
        />
      )}
    </>
  )
}

